var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6, _path4, _path5, _g, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstateHostService2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 217,
    viewBox: "0 0 314 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.6545,
    y: 122.059,
    width: 117.616,
    height: 22.2517,
    fill: "#56BA74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.271 122.059H163.583V144.31H140.271V122.059Z",
    fill: "#4A935E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3972,
    y: 121,
    width: 20.1325,
    height: 24.3709,
    fill: "#CAEADB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.074,
    y: 166.562,
    width: 117.616,
    height: 22.2517,
    fill: "#56BA74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.689 166.562H171V188.814H147.689V166.562Z",
    fill: "#4E9A63"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.8145,
    y: 165.5,
    width: 20.1325,
    height: 24.3709,
    fill: "#CAEADB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 144.312,
    width: 117.616,
    height: 22.2517,
    fill: "#49AF68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.617 144.312H151.928V166.564H128.617V144.312Z",
    fill: "#2A7940"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 59.7427,
    y: 143.25,
    width: 20.1325,
    height: 24.3709,
    fill: "#C6E0D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8748 36.7773V86.0612L45.3709 76.0996V36.7773H23.8748Z",
    fill: "#3A7EFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175 105L90 40.8361L5 105",
    stroke: "#3A7EFC",
    strokeWidth: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2300_4286)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 5,
    width: 155.498,
    height: 199,
    rx: 4,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.5,
    y: 5.5,
    width: 154.498,
    height: 198,
    rx: 3.5,
    stroke: "#EFF3F8"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.466 36.6551V45.4271H209.086V45.0531H206.434V43.6591H209.086V36.6551H211.466ZM198.478 41.9251C201.436 41.9081 205.04 41.8911 208.27 41.6191L208.406 43.0811C207.097 43.2511 205.771 43.3531 204.462 43.4211V45.4611H202.082V43.5061C200.909 43.5401 199.77 43.5401 198.716 43.5231L198.478 41.9251ZM199.464 39.1371C199.481 37.7771 201.028 36.8591 203.34 36.8591C205.635 36.8591 207.199 37.7771 207.216 39.1371C207.199 40.5481 205.635 41.4151 203.34 41.4151C201.028 41.4151 199.481 40.5481 199.464 39.1371ZM200.62 47.4671V45.8691H211.466V49.5411H203.034V50.1531H211.772V51.7851H200.688V48.0451H209.086V47.4671H200.62ZM201.742 39.1371C201.725 39.6131 202.337 39.8511 203.34 39.8511C204.36 39.8511 204.972 39.6131 204.972 39.1371C204.972 38.6611 204.36 38.3891 203.34 38.3891C202.337 38.3891 201.725 38.6611 201.742 39.1371ZM218.168 40.3271C218.151 42.8091 218.678 45.3251 220.786 46.7191L219.494 48.5551C218.253 47.8071 217.471 46.5831 216.995 45.1381C216.468 46.7531 215.601 48.0961 214.292 48.8951L212.83 47.1271C215.142 45.6821 215.839 42.9961 215.822 40.4291V37.9131H218.168V40.3271ZM219.188 43.6251V41.6871H220.99V36.8591H223.2V51.2071H220.99V43.6251H219.188ZM224.118 51.8871V36.6551H226.396V51.8871H224.118ZM240.334 38.1511V40.0211H237.41C237.461 41.4321 238.464 42.9281 240.912 43.5571L239.824 45.3931C238.107 44.9681 236.934 44.0671 236.254 42.9111C235.591 44.2371 234.401 45.2911 232.616 45.7671L231.494 43.8971C233.959 43.2341 234.962 41.6021 235.03 40.0211H232.072V38.1511H235.03V36.5871H237.41V38.1511H240.334ZM234.044 48.9291C234.027 47.0931 236.05 46.0561 239.314 46.0391C242.578 46.0561 244.584 47.0931 244.584 48.9291C244.584 50.8161 242.578 51.9041 239.314 51.8871C236.05 51.9041 234.027 50.8161 234.044 48.9291ZM236.424 48.9291C236.407 49.6941 237.393 50.0851 239.314 50.0851C241.269 50.0851 242.221 49.6941 242.238 48.9291C242.221 48.2151 241.269 47.8751 239.314 47.8751C237.393 47.8751 236.407 48.2151 236.424 48.9291ZM239.892 42.5371V40.6331H242.17V36.6551H244.55V45.8691H242.17V42.5371H239.892ZM258.664 37.5051V38.8991C258.681 40.3101 258.681 41.8571 258.307 43.9651H260.228V45.8691H254.414V51.8871H252V45.8691H246.356V43.9651H255.893C256.233 42.0951 256.284 40.6671 256.284 39.4091H247.886V37.5051H258.664ZM213.536 58.6551V73.8871H211.258V66.3391H210.068V73.1731H207.824V58.8931H210.068V64.4351H211.258V58.6551H213.536ZM200.922 70.2491V60.2871H203.336V68.1581C204.475 68.1071 205.716 68.0051 207.042 67.7331L207.28 69.8071C205.291 70.1471 203.54 70.2491 202.01 70.2491H200.922ZM228.943 65.7611V67.6651H215.071V65.7611H218.097V64.0441C217.009 63.5511 216.397 62.7861 216.397 61.8171C216.397 59.9641 218.59 58.8591 222.007 58.8591C225.39 58.8591 227.583 59.9641 227.583 61.8171C227.583 62.8031 226.937 63.5851 225.815 64.0781V65.7611H228.943ZM216.635 71.0991C216.618 69.3141 218.641 68.3281 221.973 68.3451C225.288 68.3281 227.294 69.3141 227.311 71.0991C227.294 72.9011 225.288 73.8701 221.973 73.8531C218.641 73.8701 216.618 72.9011 216.635 71.0991ZM218.879 61.8171C218.879 62.5821 219.967 62.9221 222.007 62.9391C224.013 62.9221 225.118 62.5821 225.135 61.8171C225.118 61.0521 224.013 60.6781 222.007 60.6951C219.967 60.6781 218.879 61.0521 218.879 61.8171ZM219.049 71.0991C219.049 71.7791 219.984 72.1021 221.973 72.0851C223.928 72.1021 224.897 71.7791 224.897 71.0991C224.897 70.4191 223.928 70.1471 221.973 70.1471C219.984 70.1471 219.049 70.4191 219.049 71.0991ZM220.511 65.7611H223.435V64.6391C222.993 64.6901 222.517 64.7071 222.007 64.7071C221.48 64.7071 220.97 64.6901 220.511 64.6391V65.7611ZM243.635 65.5911V67.4951H229.763V65.5911H243.635ZM230.307 63.2791C233.146 63.0411 234.489 62.1401 234.897 61.2391H231.021V59.3351H242.377V61.2391H238.467C238.875 62.1231 240.235 63.0411 243.125 63.2791L242.275 65.1491C239.317 64.8941 237.481 63.8401 236.665 62.4291C235.883 63.8231 234.064 64.8941 231.089 65.1491L230.307 63.2791ZM231.327 71.0651C231.31 69.2461 233.333 68.2091 236.665 68.2091C239.997 68.2091 241.986 69.2461 242.003 71.0651C241.986 72.8671 239.997 73.9041 236.665 73.8871C233.333 73.9041 231.31 72.8671 231.327 71.0651ZM233.741 71.0651C233.741 71.7621 234.676 72.0341 236.665 72.0511C238.62 72.0341 239.589 71.7621 239.589 71.0651C239.589 70.3511 238.62 70.0451 236.665 70.0451C234.676 70.0451 233.741 70.3511 233.741 71.0651ZM257.342 58.6551V67.5291H254.962V65.7271H252.378V66.7811H245.068V59.7431H252.378V60.7971H254.962V58.6551H257.342ZM246.836 70.8951C246.819 69.0251 248.825 67.9201 252.106 67.9031C255.37 67.9201 257.376 69.0251 257.376 70.8951C257.376 72.8161 255.37 73.9041 252.106 73.8871C248.825 73.9041 246.819 72.8161 246.836 70.8951ZM247.414 64.9111H250.032V61.6471H247.414V64.9111ZM249.216 70.8951C249.199 71.6941 250.185 72.0851 252.106 72.0851C254.027 72.0851 255.013 71.6941 255.03 70.8951C255.013 70.0791 254.027 69.7391 252.106 69.7391C250.185 69.7391 249.199 70.0791 249.216 70.8951ZM252.378 63.8231H254.962V62.6671H252.378V63.8231Z",
    fill: "#374969"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M259.246 124.512V132.184H251.294L245.302 156.04H236.062L229.006 124.456L221.95 156.04H212.71L206.718 132.184H198.766V124.512H204.814L201.286 110.4H211.142L213.998 124.512H221.11L224.19 110.4H234.326L237.462 124.512H244.518L247.374 110.4H256.726L253.198 124.512H259.246ZM215.566 132.184L217.414 141.2L219.374 132.184H215.566ZM241.158 141.368L243.006 132.184H239.142L241.158 141.368Z",
    fill: "#6DAE81"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2300_4286",
    x: 140,
    y: 0,
    width: 173.498,
    height: 217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2300_4286"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2300_4286"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2300_4286",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstateHostService2);
export default __webpack_public_path__ + "static/media/EstateHostService2.d559264cf9fa0dd0145f7e3d09ee05cf.svg";
export { ForwardRef as ReactComponent };